<template>
  <div class="franchise">
    <div class="franchise-bg">
      <div class="franchise-bg-img">
        <img src="@/assets/franchise/banner.png" alt="">
      </div>
      <div class="franchise-bg-breadcrumb">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item"><a href="/">{{ $t('franchise.breadcrumb.title') }}</a></li>
            <li class="breadcrumb-item active" aria-current="page">{{ $t('franchise.breadcrumb.activeTitle') }}</li>
          </ol>
        </nav>
      </div>
      <div class="franchise-bg-position">

      </div>
      <div class="pc-fixed-icon" @click="openInquiryForm">
        <img src="@/assets/home/xinxi.png" alt="">
      </div>
    </div>

    <!-- 市场数据部分 -->
    <div class="franchise-market">
      <div class="franchise-market-div">
        <!-- 主标题 -->
        <div class="area-title-pc">
          <p>{{ franchiseList[0]?.value[0]?.title }}</p>
          <p class="area-titleBottom-pc">{{ franchiseList[0]?.value[0]?.subheading }}</p>
        </div>

        <!-- 增长率描述 -->
        <div >
          <p>
            <!-- <span class="market-growth-descriptionBold">{{ $t('franchise.titleOneBold') }}</span> -->
          </p>
        </div>

        <!-- 底部详细说明 - 新布局 -->
        <div class="market-details-new">
          <!-- 左侧部分 -->
          <div class="details-left">
            <div class="details-left-itemText details-left-itemTextOne">
              <img src="@/assets/franchise/detailsLeftOne.png" alt="">
              <span>{{ franchiseList[3]?.value[0]?.one_one_title }}</span>
            </div>
            <div class="details-left-itemText">
              <span>{{ franchiseList[3]?.value[0]?.one_one_currency }}</span>
              <span class="growth-rateLeft">{{ franchiseList[3]?.value[0]?.one_one_money }}</span>
              <span>{{ franchiseList[3]?.value[0]?.one_one_rmb }}</span>
            </div>
            <div class="details-left-itemText details-left-itemTextOne">
              <img src="@/assets/franchise/detailsLeftTwo.png" alt="">
              <span>{{ franchiseList[3]?.value[0]?.one_two_title }}</span>
            </div>
            <div class="details-left-itemText">
              <span>{{ franchiseList[3]?.value[0]?.one_one_currency }}</span>
              <span class="growth-rateLeft">{{ franchiseList[3]?.value[0]?.one_two_money }}</span>
              <span>{{ franchiseList[3]?.value[0]?.one_two_rmb }}</span>
            </div>
            <!-- <div class="details-left-echart" id="detailsLeftChart"></div> -->
          </div>

          <!-- 右侧部分 -->
          <div class="details-right">
            <!-- 右上：两个图表 -->
            <div class="charts-section">
              <!-- 左侧图表：区域市场格局 -->
              <div class="chart-item regional-chart-item">
                <div class="chart-header">
                  <!-- <span class="chart-title">{{ $t('franchise.detailsRightOneText') }}</span> -->
                  <div class="chart-content">
                    <div class="chart-year">{{ franchiseList[3]?.value[0]?.tow_title }}
                      <span class="chart-percentage">{{ franchiseList[3]?.value[0]?.tow_bfb }}</span>
                      {{ franchiseList[3]?.value[0]?.tow_year }}
                    </div>
                    <!-- <div class="chart-description"></div> -->
                    <!-- <div class="chart-suffix">
                      
                      </div> -->
                    <!-- <div class="chart-suffix">{{ $t('franchise.detailsRightOneText4') }}</div> -->
                  </div>
                </div>

                <div class="chart-visual">
                  <div class="donut-chart">
                    <div id="detailsRightChartOne"></div>
                  </div>
                </div>
              </div>

              <!-- 右侧图表：头皮主要问题 -->
              <div class="chart-item issues-chart-item">
                <div class="chart-item-content">
                  <div id="detailsRightChartTwo"></div>
                </div>

                <!-- <div class="chart-item-content">
                  <span>{{ $t('franchise.detailRightRightText') }}</span>
                  <span>
                    <strong>{{ $t('franchise.detailRightRightText2') }}</strong>
                  </span>
                  <span>{{ $t('franchise.detailRightRightText3') }}</span>
                  <span>
                    <strong>
                      {{ $t('franchise.detailRightRightText4') }}
                    </strong>
                  </span>
                  <span>{{ $t('franchise.detailRightRightText5') }}</span>
                  
                </div> -->
              </div>
            </div>

            <!-- 右下：文字内容 -->
            <!-- <div>
              <ul class="text-section">
                <li>
                  <strong>{{ $t('franchise.detailRightBottom') }}</strong>
                  <span>{{ $t('franchise.detailRightBottomText') }}</span>
                </li>
                <li>
                  {{ $t('franchise.detailRightBottomText1') }}
                  <strong>{{ $t('franchise.detailRightBottom1') }}</strong>
                  {{ $t('franchise.detailRightBottomText1s') }}
                </li>
                <li>
                  {{ $t('franchise.detailRightBottomText2') }}
                  <strong>{{ $t('franchise.detailRightBottom2') }}</strong>
                </li>
              </ul>
              <div class="text-section-last">
                <strong>{{ $t('franchise.detailLastText') }}</strong>
                <strong>{{ $t('franchise.detailLastTextRed') }}</strong>
                <strong>{{ $t('franchise.detailLastText1') }}</strong>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>

    <!-- 发展历史部分 -->
    <div class="franchise-development">
      <div class="franchise-development-div">
        <div class="area-title-pc">
          <p>{{ franchiseList[0]?.value[0]?.title }}</p>
          <p class="area-titleBottom-pc">{{ franchiseList[0]?.value[0]?.subheading }}</p>
        </div>
        
        <div class="timeline-container">
          <div class="timeline-container-cont">
          
            <div class="timeline-items">
              <div class="timeline-item" v-for="(item, index) in franchiseList[0]?.value[0]?.content" :key="index">
                <div class="timeline-top">
                  <div class="timeline-year">{{ item.year }}</div>
                  <div style="width: 100%;">
                    <div class="timeline-badge">{{ item.subheading }}</div>
                  </div>
                </div>
                <div class="timeline-line"></div>
                <div class="timeline-content">
                  <div class="timeline-dot-cont">
                    <div class="timeline-dot">
                      <div class="timeline-box"></div>
                    </div>
                  </div>
                  <div class="timeline-card">
                    <div class="card-content">
                      <!-- <p v-for="(paragraph, pIndex) in item.content" :key="pIndex" v-html="paragraph"></p> -->
                    
                    <!-- <el-timeline>
                      <el-timeline-item>
                        <p v-html="item.year_content"></p>
                      </el-timeline-item>
                    </el-timeline> -->
                    <el-timeline>
                      <el-timeline-item
                        v-for="(paragraph, pIndex) in item.year_content" :key="pIndex"
                        >
                        <p v-html="paragraph.year_content"></p>
                      </el-timeline-item>
                    </el-timeline>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 公司未来计划部分 -->
    <div class="franchise-future-plans">
      <div class="franchise-future-plans-div">
        <div class="area-title-pc">
          <p>{{ franchiseList[1]?.value[0]?.title }}</p>
          <p class="area-titleBottom-pc">{{ franchiseList[1]?.value[0]?.subheading }}</p>
        </div>
        
        <div class="future-plans-container">
          <!-- 覆盖图片 -->
          <div class="overlay-image">
            <img src="@/assets/franchise/section4.png" alt="">
          </div>
          
          <!-- 底部内容块 -->
          <div class="future-plans-content">
            <div class="future-plans-details">
              <div class="plans-main-title">
                <h3>{{ franchiseList[1]?.value[0]?.content_title }}</h3>
                <p class="plans-description">{{ franchiseList[1]?.value[0]?.content_subheading }}</p>
              </div>
              
              <div class="plans-goals">
                <div class="goal-item" v-for="(goal, index) in franchiseList[1]?.value[0]?.content" :key="index">
                  <div class="goal-number">{{ String(index + 1).padStart(2, '0') }}</div>
                  <div class="goal-content">{{ goal.info }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 各国加盟部分 -->
    <div class="franchise-countries">
      <div class="franchise-countries-div">
        <div class="countries-header">
          <h2 class="countries-title">{{ franchiseList[2]?.value[0]?.title }}</h2>
          <p class="countries-subtitle">{{ franchiseList[2]?.value[0]?.subheading }}</p>
        </div>
        
        <div class="countries-grid">
          <div class="country-card" v-for="(country, index) in franchiseList[2]?.value[0]?.content" :key="index">
            <div class="country-info">
              <h3 class="country-name">{{ country.contact_name }}</h3>
              <div class="contact-item">
                <span class="contact-label">{{ $t('franchise.countries.label') }}</span>
                <span class="contact-value">{{ country.official_url }}</span>
              </div>
              <div class="contact-item">
                <span class="contact-label">{{ $t('franchise.countries.label1') }}</span>
                <span class="contact-value">{{ country.mobile }}</span>
              </div>
            </div>
            <div class="country-icon">
              <div class="globe-icon">
                <img src="@/assets/franchise/website.png" alt="">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 咨询表单部分 -->
    <div class="home-form">
      <div class="home-form-div">
        <div class="home-form-card">
          <div class="home-form-title">{{ $t('home.inquiryCont.titleTop') }}</div>
          <div class="home-form-cont">
            <div class="home-form-cont-formCont">
              <form class="row g-3">
                <!-- <div class="form-group">
                  <label class="form-label" for="exampleFormControlSelect1">{{ $t('home.inquiryCont.form.q1') }}</label>
                  <el-select size="100%" v-model="formData.know" :placeholder="$t('error.select')">
                      <el-option v-for="value in queryList" :key="value.id" :label="value.name" :value="value.id"></el-option>
                  </el-select>
                </div>
                <div class="form-group">
                  <label class="form-label" for="exampleFormControlSelect1">{{ $t('content.follow.form.label.identity') }}</label>
                  <el-select size="100%" v-model="formData.identity" :placeholder="$t('error.select')">
                    <el-option v-for="value in $t('content.follow.identityOPtions')" :key="value.value" :label="value.label" :value="value.label"></el-option>
                  </el-select>
                </div> -->
                <div class="form-group">
                  <label class="form-label" for="exampleFormControlInput1">{{ $t('content.follow.form.label.fullname') }}</label>
                  <el-input size="100%" v-model="formData.name" placeholder="Enter"></el-input>
                </div>
                <div class="form-group">
                  <label class="form-label" for="exampleFormControlInput1">{{ $t('content.follow.form.label.contact') }}</label>
                  <el-input size="100%" v-model="formData.contact" placeholder="Enter"></el-input>
                </div>
                <div class="form-group">
                  <label class="form-label" for="exampleFormControlInput1">{{ $t('content.follow.form.label.email') }}</label>
                  <el-input size="100%" v-model="formData.email" placeholder="Enter"></el-input>
                </div>
                <div class="form-group">
                  <label class="form-label" for="exampleFormControlInput1">{{ $t('home.inquiryCont.form.q6') }}</label>
                  <el-input size="100%" v-model="formData.preferred_city" placeholder="Enter"></el-input>
                </div>
                <div class="col-auto">
                  <el-button class="custom-button" type="primary" @click="onSubmit">{{ $t('content.follow.form.buttonText') }}</el-button>
                </div>
                <!-- <div class="form-group" style="margin:0;">
                  <span class="text-muted">{{ $t('home.inquiryCont.form.note') }}</span>
                </div> -->
              </form>
            </div>
            <div class="home-form-cont-formImg">
              <img src="@/assets/home/formImg.png" alt=""></img>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { bus } from '@/utils/bus'
import { getBannerListing, getDataList } from '@/api/komo'
import { getQuestionType,getSolveOption,submitQuestion } from '@/api/komo'
export default {
  name: 'franchise-pc',
  data() {
    return {
      bannerList: [], //
      franchiseList: [],
      growthChartData: [
        { year: '2019', value: '1850', height: '40%' },
        { year: '2020', value: '1920', height: '45%' },
        { year: '2021', value: '2010', height: '50%' },
        { year: '2022', value: '2080', height: '55%' },
        { year: '2023', value: '2150', height: '60%' },
        { year: '2024', value: '2280', height: '70%' },
        { year: '2025', value: '2420', height: '75%' },
        { year: '2026', value: '2580', height: '80%' },
        { year: '2027', value: '2760', height: '85%' },
        { year: '2028', value: '2950', height: '90%' },
        { year: '2029', value: '3160', height: '95%' },
        { year: '2030', value: '3430', height: '100%' }
      ],
      timelineData: [
        {
          year: '2010',
          badge: this.$t('franchise.timelineData.badge'),
          content: [
            this.$t('franchise.timelineData.content'),
            this.$t('franchise.timelineData.contents')
          ]
        },
        {
          year: '2020',
          badge: this.$t('franchise.timelineData.badge1'),
          content: [
            this.$t('franchise.timelineData.content1')
          ]
        },
        {
          year: '2025',
          badge: this.$t('franchise.timelineData.badge2'),
          content: [
            this.$t('franchise.timelineData.content2'),
            this.$t('franchise.timelineData.contents2')
          ]
        }
      ],
      futureGoals: [
        {
          content: this.$t('franchise.futureGoals.content')
        },
        {
          content: this.$t('franchise.futureGoals.content1')
        },
        {
          content: this.$t('franchise.futureGoals.content2'),
        }
      ],
      countriesData: [
        {
          name: this.$t('franchise.countriesData.name'),
          website: this.$t('franchise.countriesData.website'),
          phone: '13800998800'
        },
        {
          name: this.$t('franchise.countriesData.name1'),
          website: this.$t('franchise.countriesData.website1'),
          phone: '13800998800'
        },
        {
          name: this.$t('franchise.countriesData.name2'),
          website: this.$t('franchise.countriesData.website2'),
          phone: '13800998800'
        },
        {
          name: this.$t('franchise.countriesData.name3'),
          website: this.$t('franchise.countriesData.website3'),
          phone: '13800998800'
        },
        {
          name: this.$t('franchise.countriesData.name4'),
          website: this.$t('franchise.countriesData.website4'),
          phone: '13800998800'
        }
      ],
      queryList: [],
      checkData:[],
      formData: {
        name: '',
        // know: '',
        // identity:'',
        contact: '',
        email: '',
        preferred_city:''
      },
    }
  },
  async created() {
    await this.initData();
    await this.getFormData();
  },
  methods: {
    async getFormData () {
      const queryResult = await getQuestionType();
      this.queryList = queryResult.data.list;

      const checkList = await getSolveOption();
      this.checkData = checkList.data.list
    },
    async initData () {
      const result = await getBannerListing('8');
      this.bannerList = result.data.list;

      const franchiseDatalist = await getDataList(localStorage.getItem('pageId'));
      this.franchiseList = franchiseDatalist.data.list;
      console.log(this.franchiseList)
      if (this.franchiseList && this.franchiseList[3]) {
        console.log(this.franchiseList[3]);
        let towChartData = {
          name: this.franchiseList[3]?.value[0]?.tow_echart_name,
          data: [],
          color:[]
        }
        for (let i = 0; i < this.franchiseList[3]?.value[0]?.tow_ecahrt_color.length; i++) {
          towChartData.data.push({
            value: this.franchiseList[3]?.value[0]?.tow_ecahrt_color[i].tow_ecahrt_global_value,
            name: this.franchiseList[3]?.value[0]?.tow_ecahrt_color[i].tow_ecahrt_name
          })
          towChartData.color.push(this.franchiseList[3]?.value[0]?.tow_ecahrt_color[i].tow_ecahrt_color)
        }

        let threeChartData = {
          title: this.franchiseList[3]?.value[0]?.three_title,
          name: this.franchiseList[3]?.value[0]?.three_name,
          data: [],
          color:[]
        }
        for (let i = 0; i < this.franchiseList[3]?.value[0]?.three_data.length; i++) {
          threeChartData.data.push({
            value: this.franchiseList[3]?.value[0]?.three_data[i].problem_value,
            name: this.franchiseList[3]?.value[0]?.three_data[i].problem_name
          })
          threeChartData.color.push(this.franchiseList[3]?.value[0]?.three_data[i].problem_color)
        }
        // rightChartTwo
        setTimeout(() => {
          this.detailsRightInitChartOne(towChartData);
          this.detailsRightInitChartTwo(threeChartData);
        }, 10);
      }
    },
    openInquiryForm(){
      bus.$emit('inquiry-form', true)
    },
    // Chart =============================================
    // leftChart
    detailsLeftInitChart() {
      const detailsLeftChart = this.$echarts.init(document.getElementById('detailsLeftChart'));
      const option = {
        title: {
          text: this.$t('franchise.detailsLeftFiveChartTitle'),
        },
        grid: {
          left: '6%',
          right: '4%',
          bottom: '4%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: ['2018', '2019', '2020', '2021', '2022', '2023', '2024', '2025', '2026', '2027', '2028', '2029', '2030']
        },
        yAxis: {
          name: this.$t('franchise.detailsLeftFiveChartyAxis'),
          type: 'value',
          nameLocation: 'middle',
          nameGap: 32,
          nameTruncate: {
            maxWidth: 300,
            ellipsis: '...',
          },
          axisLine: {
            lineStyle: {
              color: '#666'
            }
          },
          splitLine: {
            lineStyle: {
              color: '#bebebe'
            }
          }           // 根据需要调整与轴的距离，默认为15
        },
        series: [
          {
            data: [120, 200, 150, 80, 70, 110, 130,120, 200, 150, 80, 70, 110],
            type: 'bar',
            itemStyle: {
              color: '#b2b9ae' // 柱子颜色
            },
          }
        ]
      };
      detailsLeftChart.setOption(option);
    },
    // rightChartOne
    detailsRightInitChartOne (chartData) {
      const detailsRightChartOne = this.$echarts.init(document.getElementById('detailsRightChartOne'));
      const option = {
				tooltip: {
					trigger: 'item'
        },
        legend: {
          top: '0',
          left: 'center',
          icon: 'circle',
          textStyle: {
            color: '#333' // 默认状态颜色
          },
          inactiveColor: '#999', // 未选中状态颜色
        },
				series: [
					{
						name: chartData.name,
						type: 'pie',
						radius: ['40%', '70%'],
						avoidLabelOverlap: false,
						label: {
							show: false,
							position: 'center'
						},
						emphasis: {
							label: {
								show: false,
								fontSize: 40,
								fontWeight: 'bold'
							}
						},
						labelLine: {
							show: false
						},
						data: chartData.data,
						itemStyle: {
							color: function (params) {
								// 自定义颜色逻辑
								const colorList = chartData.color; // 颜色数组
								return colorList[params.dataIndex];
							}
						},
					}
				]
			};
			detailsRightChartOne.setOption(option);
    },
    // rightChartTwo
    detailsRightInitChartTwo (chartData) {
      const detailsRightChartTwo = this.$echarts.init(document.getElementById('detailsRightChartTwo'));
      const option = {
				tooltip: {
					trigger: 'item'
        },
        title: {
          text: chartData.title,
          top:'0'
        },
        legend: {
          top: '10%',
          left: 'center',
          icon: 'circle',
          textStyle: {
            color: '#333' // 默认状态颜色
          },
          inactiveColor: '#999', // 未选中状态颜色
        },
				series: [
					{
						name: chartData.name,
            type: 'pie',
            center: ['50%', '60%'],
						radius: ['30%', '60%'],
						avoidLabelOverlap: false,
						label: {
							show: false,
							position: 'center'
						},
						emphasis: {
							label: {
								show: false,
								fontSize: 40,
								fontWeight: 'bold'
							}
						},
						labelLine: {
							show: false
						},
						data: chartData.data,
						itemStyle: {
							color: function (params) {
								// 自定义颜色逻辑
								const colorList = chartData.color; // 颜色数组
								return colorList[params.dataIndex];
							}
						},
					}
				]
			};
			detailsRightChartTwo.setOption(option);
    },
    // Chart end ========================================
    onSubmit() {
      // 校验想知道什么
      // if (!this.formData.know) {
      //     this.$message.error(this.$t('error.select'))
      //     return;
      // }
      // 校验身份
      // if (this.formData.identity ===''|| this.formData.identity == null) {
      //     this.$message.error(this.$t('error.select'))
      //     return;
      // }
      // 校验名字
      if (!this.formData.name) {
          this.$message.error(this.$t('error.name'))
          return;
      }
      
      // 校验手机号
      if (!this.formData.contact) {
          this.$message.error(this.$t('error.phone'))
          return;
      }
      if (!this.validatePhone(this.formData.contact)) {
          this.$message.error(this.$t('error.phoneFormat'))
          return;
      }
      
      // 校验邮箱
      if (!this.formData.email) {
          this.$message.error(this.$t('error.email'))
          return;
              } 
      if (!this.validateEmail(this.formData.email)) {
          this.$message.error(this.$t('error.emailFormat'))
          return;
      }
      // 校验checkbox
      // if (!this.formData.type.length) {
      //     this.$message.error(this.$t('error.select'))
      //     return;
      // }
      // 校验城市
      if (!this.formData.preferred_city) {
          this.$message.error(this.$t('error.name'))
          return;
      }
      let params = {
          body_option: "franchisee",
          // question_type_id: this.formData.know,
          // body_option: this.formData.identity === 0 ? "consumer" : "franchisee",
          full_name: this.formData.name,
          mobile: this.formData.contact,
          email: this.formData.email,
          preferred_city: this.formData.preferred_city,
          problem: this.formData.type
      }
      submitQuestion(params).then(res => { 
          if (res.error == 0) {
            this.$message.success(res.message);
            //提交成功 重置表单
            this.formData =  {
                name: '',
                know: '',
                identity:'',
                contact: '',
                email: '',
                preferred_city:''
            }
          } else {
            this.$message.error(res.message)
          }
      })
    },
    //验证手机号格式
		validatePhone(phone) {
			// 验证手机号是否为纯数字
			const numberRegex = /^1[34578]\d{9}$/;
			return numberRegex.test(phone);
    },
    //验证邮箱格式
    validateEmail(email) {
			const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
			return emailRegex.test(email);
		},
  },
  mounted () {
    // leftChart
    // this.detailsLeftInitChart();
    
  },
}
</script>

<style scoped>
.franchise {
  width: 100%;
  height: 100%;
  background: #F8F9FC;
}

/* Banner部分 - 参考technology.vue */
.franchise-bg {
  width: 100%;
  height: 100%;
  position: relative;
  padding-bottom: 2%;
}

.franchise-bg-img {
  width: 100%;
  height: 580px;
}

.franchise-bg-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.franchise-bg-breadcrumb {
  width: 80%;
  height: 10%;
  background: #FFFFFF;
  box-shadow: 0px 13px 45px 0px rgba(210, 210, 210, 0.5);
  border-radius: 60px;
  display: flex;
  align-items: center;
  padding-left: 3%;
  position: absolute;
  top: calc(580px - 5%);
  left: 10%;
  z-index: 1;
}

.franchise-bg-breadcrumb .breadcrumb {
  margin: 0;
  font-size: 1.5rem;
}

.franchise-bg-breadcrumb .breadcrumb a {
  color: #959595;
  text-decoration: none;
}

.franchise-bg-breadcrumb .breadcrumb-item.active {
  font-weight: bold;
  color: #1E1E1E;
}

.franchise-bg-position {
  width: 80%;
  margin: 5% auto 0;
  height: 46px;
  display: flex;
  justify-content: center;
  gap: 8%;
}

.franchise-bg-information {
  position: fixed;
  bottom: 0%;
  right: 7%;
  width: 12vw;
  height: 12vw;
  cursor: pointer;
  z-index: 99;
}

.franchise-bg-information img {
  width: 100%;
  height: 100%;
}

/* 市场数据部分 */
.franchise-market {
  width: 100%;
  padding:0 0 6%;
  background: #FBF7EB;
}

.franchise-market-div {
  width: 80%;
  margin: 0 auto;
}

/* 主标题 */
.market-main-title {
  text-align: center;
  margin-bottom: 3%;
}

.market-main-title h1 {
  font-size: 3.5vw;
  font-weight: bold;
  color: #1E1E1E;
  margin: 0;
  letter-spacing: -0.02em;
}

/* 增长率描述 */
.market-growth-description {
  text-align: center;
  margin-bottom: 1%;
}

.market-growth-description p {
  font-size: 2rem;
  color: #1E1E1E;
  margin: 0;
}
.market-growth-descriptionBold{
  font-weight: bold;
}

.growth-rate {
  color: #FF4444;
  font-weight: bold;
  font-size: 2.2rem;
}

/* 数据展示区域 */
.market-data-section {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 3%;
  margin: 4% 0;
}

/* 左侧市场规模卡片 */
.market-scale-card {
  background: linear-gradient(135deg, #A8D5BA 0%, #7FB069 100%);
  border-radius: 20px;
  padding: 4%;
  color: white;
  position: relative;
  overflow: hidden;
}

.scale-card-header {
  display: flex;
  align-items: center;
  margin-bottom: 3%;
}

.scale-icon {
  width: 40px;
  height: 40px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
}

.scale-title {
  font-size: 1.2rem;
  font-weight: 600;
}

.scale-value {
  margin-bottom: 4%;
}

.value-text {
  font-size: 1.1rem;
  opacity: 0.9;
}

.value-number {
  font-size: 3.5rem;
  font-weight: bold;
  color: #FF4444;
  margin: 0 8px;
}

.value-unit {
  font-size: 1.3rem;
  opacity: 0.9;
}

.scale-card-divider {
  height: 1px;
  background: rgba(255, 255, 255, 0.3);
  margin: 4% 0;
}

.scale-future {
  display: flex;
  align-items: center;
  margin-bottom: 3%;
}

.future-icon {
  width: 32px;
  height: 32px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
}

.future-title {
  font-size: 1.1rem;
  font-weight: 600;
}

/* 增长趋势图 */
.growth-chart {
  margin-top: 6%;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  padding: 3%;
}

.chart-title {
  font-size: 1.1rem;
  margin-bottom: 3%;
  opacity: 0.8;
}
.chart-content{
}

.chart-bars {
  display: flex;
  align-items: end;
  justify-content: space-between;
  height: 80px;
  gap: 2px;
}

.bar {
  flex: 1;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 2px 2px 0 0;
  position: relative;
  min-height: 10px;
  display: flex;
  flex-direction: column;
  justify-content: end;
  align-items: center;
}

.bar-value {
  font-size: 0.6rem;
  position: absolute;
  top: -15px;
  white-space: nowrap;
}

.bar-year {
  font-size: 0.6rem;
  position: absolute;
  bottom: -15px;
  opacity: 0.8;
}

/* 中间区域模式卡片 */
.regional-pattern-card {
  background: #E8E8E8;
  border-radius: 20px;
  padding: 4%;
  position: relative;
}

.pattern-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 4%;
}

.pattern-title {
  font-size: 1.2rem;
  font-weight: 600;
  color: #1E1E1E;
}

.pattern-legend {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.legend-item {
  display: flex;
  align-items: center;
  font-size: 0.9rem;
}

.legend-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-right: 6px;
}

.legend-dot.asia {
  background: #FF4444;
}

.legend-dot.other {
  background: #CCCCCC;
}

.pattern-content {
  text-align: center;
  margin-bottom: 4%;
}

.pattern-year {
  font-size: 1.1rem;
  color: #1E1E1E;
  margin-bottom: 1%;
}

.pattern-description {
  font-size: 1rem;
  color: #666;
  margin-bottom: 1%;
}

.pattern-percentage {
  font-size: 3.5rem;
  font-weight: bold;
  color: #FF4444;
  margin-bottom: 1%;
}

.pattern-suffix {
  font-size: 1rem;
  color: #666;
}

.pie-chart-container {
  display: flex;
  justify-content: center;
}

.pie-chart {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  background: conic-gradient(#FF4444 0deg 144deg, #CCCCCC 144deg 360deg);
  position: relative;
}

.pie-chart::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 60px;
  height: 60px;
  background: #E8E8E8;
  border-radius: 50%;
}

/* 右侧主要问题卡片 */
.main-issues-card {
  background: #E8E8E8;
  border-radius: 20px;
  padding: 4%;
  position: relative;
}

.issues-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 4%;
}

.issues-title {
  font-size: 1.2rem;
  font-weight: 600;
  color: #1E1E1E;
}

.issues-legend {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.issues-legend .legend-item {
  font-size: 0.8rem;
}

.legend-dot.dandruff {
  background: #FF6B6B;
}

.legend-dot.oily {
  background: #4ECDC4;
}

.legend-dot.itchy {
  background: #45B7D1;
}

.legend-dot.other {
  background: #FFA726;
}

.issues-content {
  margin-bottom: 4%;
}

.issues-content p {
  font-size: 0.95rem;
  line-height: 1.6;
  color: #1E1E1E;
  margin: 0;
}

.issues-pie-chart-container {
  display: flex;
  justify-content: center;
}

.issues-pie-chart {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background: conic-gradient(#FF6B6B 0deg 108deg,
      #4ECDC4 108deg 180deg,
      #45B7D1 180deg 252deg,
      #FFA726 252deg 360deg);
  position: relative;
}

.issues-pie-chart::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 50px;
  height: 50px;
  background: #E8E8E8;
  border-radius: 50%;
}

/* 底部详细说明 - 新布局 */
.market-details-new {
  display: flex;
  flex-direction: row;
  gap: 2vw;
  height: 20vw;
}

/* 左侧部分 */
.details-left {
  background: #d4ddc8;
  border-radius: 20px;
  padding: 1.5vw 1vw;
  width: 21vw;
  font-size: 1vw;
}

.details-left-itemText{
  display: flex;
  align-items: center;
  gap: 0.5vw;
}
.details-left-itemTextOne{
  gap: 1vw;
}
.details-left-itemText img{
  width: 2.5vw;
  height: 2.5vw;
}
.details-left-echart{
  height: 64%;
}
.growth-rateLeft {
    color: #FF4444;
    font-weight: bold;
    font-size:1.8vw;
}

.detail-points {
  margin-bottom: 0;
}

.detail-point {
  display: flex;
  align-items: flex-start;
  margin-bottom: 3%;
  font-size: 1.1rem;
  line-height: 1.8;
}

.point-bullet {
  color: #1E1E1E;
  margin-right: 12px;
  margin-top: 2px;
}

.point-text {
  flex: 1;
  color: #1E1E1E;
}

.point-text strong {
  color: #FF4444;
  font-weight: bold;
}

/* 右侧部分 */
.details-right {
  display: flex;
  flex-direction: column;
}

/* 右上：图表区域 */
.charts-section {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 3%;
  height: 100%;
}

/* 图表项 */
.chart-item {
  background: #cfd2c7;
  border-radius: 20px;
  padding: 4% 4% 2%;
  position: relative;
  display: flex;
  flex-direction: column;
}

.chart-item-content {
  flex: 1;
  font-size: 1vw;
}

.issues-chart-item .chart-item-content:first-child {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: center;
  width: 100%;
}
#detailsRightChartTwo{
  height: 100%;
  width: 100%;
}
/* 图表头部 */
.chart-header {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.chart-title {
  font-size: 1.2vw;
  font-weight: 600;
  color: #1E1E1E;
}

.chart-legend {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 4px;
}

.chart-legend .legend-item {
  display: flex;
  align-items: center;
  font-size: 0.8rem;
}

.chart-legend .legend-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-right: 4px;
}

/* 图例颜色 */
.legend-dot.global {
  background: #CCCCCC;
}

.legend-dot.asia-pacific {
  background: #FF4444;
}

.legend-dot.red {
  background: #FF4444;
}

.legend-dot.yellow {
  background: #FFD700;
}

.legend-dot.white {
  background: #FFFFFF;
  border: 1px solid #CCCCCC;
}

.legend-dot.green {
  background: #90EE90;
}

.legend-dot.blue {
  background: #87CEEB;
}

.legend-dot.pink {
  background: #FFB6C1;
}

/* 区域图表内容 */
.regional-chart-item .chart-content {
  /* margin-bottom: 4%; */
  width: 100%;
}

.chart-year {
  font-size: 1vw;
  color: #1E1E1E;
  margin-top: 4%;
}

.chart-description {
  font-size: 1vw;
  color: #1E1E1E;
  margin-bottom: 1%;
}

.chart-percentage {
  font-size: 2.5rem;
  font-weight: bold;
  color: #FF4444;
  margin-bottom: 1%;
  margin-right: 2%;
  margin-left: 2%;
}

.chart-suffix {
  font-size: 1vw;
  color: #1E1E1E;
}

/* 图表可视化 */
.chart-visual {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
}

.donut-chart {
  width: 100%;
  height: 100%;
  position: relative;
}
#detailsRightChartOne{
  width: 100%;
  height: 100%;
}

/* 区域图表 */
.regional-donut {
  background: conic-gradient(#FF4444 0deg 144deg, #CCCCCC 144deg 360deg);
}

/* 问题图表 */
.issues-donut {
  background: conic-gradient(#FF4444 0deg 60deg,
      #FFD700 60deg 120deg,
      #FFFFFF 120deg 180deg,
      #90EE90 180deg 240deg,
      #87CEEB 240deg 300deg,
      #FFB6C1 300deg 360deg);
}

/* 右下：文字区域 */
.text-section {
  border-radius: 20px;
  padding: 1vw 1vw 0.2vw;
  margin: 0;
  font-size: 1vw;
}

.text-section p {
  font-size: 1rem;
  line-height: 1.6;
  color: #1E1E1E;
  margin: 0;
}
.text-section-last{
  font-size: 1vw;
}

/* 底部结论 */
.market-conclusion-new {
  grid-column: 1 / -1;
  background: white;
  border-radius: 20px;
  padding: 4%;
  margin-top: 2%;
}

.market-conclusion-new p {
  font-size: 1.2rem;
  line-height: 1.8;
  color: #1E1E1E;
  margin: 0;
  text-align: center;
}

.highlight-text {
  color: #FF4444;
  font-weight: bold;
}

/* 发展历史部分 */
.franchise-development {
  width: 100%;
  height: 100%;
  /* padding: 8% 0; */
  /* background: #D5DCC8; */
}

.franchise-development-div {
  width: 100%;
  height: 100%;
}

.development-header {
  text-align: center;
  margin-bottom: 8%;
}

.development-title {
  font-size: 3.5rem;
  font-weight: bold;
  color: #1E1E1E;
  margin: 0 0 2% 0;
  letter-spacing: -0.02em;
}

.development-subtitle {
  font-size: 1.8rem;
  color: #959595;
  margin: 0;
}

.timeline-container {
  width: 100%;
  background: #d5dcc880;
  margin: 0 auto;
  padding-bottom: 7vw;
}
.timeline-container-cont{
  position: relative;
  width: 80%;
  height: 100%;
  margin: 0 auto;
  padding: 4% 3%;
}

.timeline-items {
  display: flex;
  justify-content: space-between;
  position: relative;
  z-index: 2;
}

.timeline-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position: relative;
  width: calc(100% / 3);
}
.timeline-top{
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 62%;
}

.timeline-line {
  height: 6px;
  background: #64715d3b;
  width: 100%;
}

.timeline-year {
  font-size: 3.5rem;
  font-weight: bold;
  color: #64715D;
  margin-bottom: 2%;
  letter-spacing: -0.02em;
  align-self: flex-start;
  text-align: center;
  width: 100%;
}

.timeline-badge {
  color: #1E1E1E;
  padding: 4% 5%;
  font-size: 0.8vw;
  font-weight: 600;
  margin-bottom: 3vw;
  white-space: nowrap;
  text-align: center;
  align-self: flex-start;
  background: #D5DCC8;
  border-radius: 30px;
  /* width: 9vw; */
  font-family: MicrosoftYaHei;
}

.timeline-dot-cont{
  width: 100%;
  padding-left: calc(1.3vw - 16px - 8px);
}
.timeline-dot {
  width: 64px;
  height: 64px;
  background: #64715d3b;
  border-radius: 50%;
  margin-bottom: 8%;
  box-shadow: 0 0 0 2px #D0D0D0;
  /* position: absolute;
  top: 140px;
  left: 0; */
  z-index: 3;
  display: flex;
  justify-content: center;
  align-items: center;
}
.timeline-box{
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #64715D;
  position: relative;
}

/* .timeline-box::after {
  content: '';
  width: 6%;
  height: 6.7vw;
  background: #64715d;
  display: block;
  margin: auto;
} */

.timeline-content {
  width: 100%;
  position: relative;
  padding-left: 0;
  display: flex;
  flex-direction: column;
  margin: -36px 2vw 0;
}

/* .timeline-content::before {
  content: '';
  position: absolute;
  top: 0px;
  left: 29px;
  width: 1px;
  height: 23px;
  background: #64715D;
  z-index: 1;
} */

.timeline-card {
  background: #FFFFFF;
  border-radius: 20px;
  padding: 0;
  box-shadow: 0px 8px 30px rgba(0, 0, 0, 0.1);
  border: 1px solid #E8E8E8;
  min-height: 200px;
  width: 23vw;
}

.card-content {
  padding: 1.6vw 1.3vw;
}
.card-content .el-timeline{
  padding: 0;
}
.card-content :deep(.el-timeline-item__node){
  background: #FFFFFF;
  border: 2px solid #64715D;
}
.card-content :deep(.el-timeline-item__node--normal){
  width: 20px;
  height: 20px;
}
.card-content :deep(.el-timeline-item__tail){
  left: 8px;
  border-left: 3px solid #64715D;
}
.card-content p {
  font-size: 1rem;
  line-height: 1.8;
  color: #1E1E1E;
  margin-bottom: 4%;
  text-align: left;
}

.card-content p:last-child {
  margin-bottom: 0;
}

.highlight-red {
  color: #FF4444;
  font-weight: bold;
}


/* 公司未来计划部分 */
.franchise-future-plans {
  width: 100%;
  padding: 8% 0;
  background: #F8F9FC;
}

.franchise-future-plans-div {
  width: 87.29vw;
  margin: 0 auto;
}

.future-plans-header {
  text-align: center;
  margin-bottom: 6%;
}

.future-plans-title {
  font-size: 3.5rem;
  font-weight: bold;
  color: #1E1E1E;
  margin: 0 0 2% 0;
  letter-spacing: -0.02em;
}

.future-plans-subtitle {
  font-size: 1.8rem;
  color: #959595;
  margin: 0;
}

.future-plans-container {
  position: relative;
}

/* 覆盖图片 */
.overlay-image {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translate(0, -50%);
  width: 29.17vw;
  height: 29.17vw;
  z-index: 2;
}
.overlay-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* 底部内容块 */
.future-plans-content {
  width: 72.71vw;
  background: #FFFFFF;
  border-radius: 30px;
  padding: 7vw 4vw;
  box-shadow: 0px 8px 30px rgba(0, 0, 0, 0.1);
  margin-left: auto;
  border: 2px solid #1E1E1E;
}

.business-illustration {
  width: 100%;
  height: 100%;
  position: relative;
  background: linear-gradient(135deg, #E3F2FD 0%, #BBDEFB 100%);
  border-radius: 15px;
  overflow: hidden;
}

.illustration-elements {
  position: relative;
  width: 100%;
  height: 100%;
}

/* 插图元素样式 */
.person {
  position: absolute;
  width: 60px;
  height: 80px;
  border-radius: 30px 30px 10px 10px;
}

.person-1 {
  background: #2196F3;
  top: 20%;
  left: 60%;
  transform: rotate(-5deg);
}

.person-2 {
  background: #FFC107;
  bottom: 30%;
  left: 20%;
  transform: rotate(5deg);
}

.person-3 {
  background: #4CAF50;
  bottom: 20%;
  right: 25%;
  transform: rotate(-3deg);
}

.money-icon {
  position: absolute;
  width: 40px;
  height: 40px;
  background: #FFD700;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 1.2rem;
  color: #1E1E1E;
}

.money-1 {
  top: 15%;
  left: 15%;
}

.money-2 {
  bottom: 15%;
  right: 15%;
}

.gear {
  position: absolute;
  width: 35px;
  height: 35px;
  background: #9E9E9E;
  border-radius: 10%;
}

.gear-1 {
  top: 40%;
  left: 10%;
  transform: rotate(15deg);
}

.gear-2 {
  top: 60%;
  right: 10%;
  transform: rotate(-15deg);
}

/* 内容区域 */
.future-plans-details {
  width: 100%;
  padding-left: 15vw;
}

.plans-main-title {
  margin-bottom: 8%;
}

.plans-main-title h3 {
  font-size: 2.5rem;
  font-weight: bold;
  color: #64715D;
  margin: 0 0 3% 0;
  letter-spacing: 0.05em;
}

.plans-description {
  font-size: 1.3rem;
  color: #64715D;
  line-height: 1.8;
  margin: 0;
}

.plans-goals {
  display: flex;
  flex-direction: column;
  gap: 1vw;
}

.goal-item {
  display: flex;
  align-items: center;
  gap: 3%;
}

.goal-number {
  flex: 0 0 auto;
  width: 50px;
  height: 50px;
  background: #1E1E1E;
  color: #FFFFFF;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  font-weight: bold;
}

.goal-content {
  flex: 1;
  font-size: 1.2rem;
  color: #1E1E1E;
  line-height: 1.8;
  height: 100%;
}

/* 各国加盟部分 */
.franchise-countries {
  width: 80%;
  margin: 0 auto;
  padding: 6% 0 7%;
  background: #D5DCC880;
  border-radius: 40px;
}

.franchise-countries-div {
  width: 100%;
  margin: 0 auto;
}

.countries-header {
  text-align: center;
  margin-bottom: 6%;
}

.countries-title {
  font-size: 2.5vw;
  font-weight: bold;
  color: #1E1E1E;
  margin: 0 0 2% 0;
  letter-spacing: -0.02em;
}

.countries-subtitle {
  font-size: 1.5vw;
  color: #959595;
  margin: 0;
}

.countries-grid {
  display: flex;
  gap: 1vw;
  flex-wrap: wrap;
  justify-content: center;
}

.country-card {
  width: 23vw;
  background: #FFFFFF;
  border-radius: 20px;
  padding: 1.56vw 2.08vw;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0px 8px 30px rgba(0, 0, 0, 0.1);
  transition: transform 0.8s ease;
}

.country-card:hover {
  transform: translateY(-5px);
}

.country-info {
  flex: 1;
}

.country-name {
  font-size: 1.2vw;
  font-weight: bold;
  color: #1E1E1E;
  margin: 0 0 4% 0;
}

.contact-item {
  display: flex;
  align-items: center;
  margin-bottom: 2%;
  font-size: 0.8vw;
}

.contact-item:last-child {
  margin-bottom: 0;
}

.contact-label {
  color: #959595;
  margin-right: 2%;
  white-space: nowrap;
}

.contact-value {
  color: #1E1E1E;
  font-weight: 500;
}

.country-icon {
  flex: 0 0 auto;
  margin-left: 4%;
}

.globe-icon {
  width: 4.17vw;
  height: 4.17vw;
  background: #F5F5F5;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.globe-icon img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}


/* form ===================================  */
.home-form{
  width: 100%;
  margin: 0 auto;
  padding: 3% 0 5%;
}
.home-form-div{
  margin-top: 20px;
  width: 80%;
  margin: 0 auto;
  height: 85vh;
  position: relative;
}
.home-form-card{
  background: #FFFFFF;
  box-shadow: 0px 13px 45px 0px rgba(210,210,210,0.5);
  border-radius: 30px;
  width: 100%;
  height: 81vh;
  position: absolute;
  top: 0;
  z-index: 1;
}
.home-form-title{
  margin: 0;
  padding: 2% 0 4% 0;
  text-align: center;
  font-weight: bold;
  font-size: 2.5vw;
  color: #1E1E1E;
}
.home-form-cont{
  width: 100%;
  display: flex;
  padding: 0 3% 2%;
  height: 62vh;
}
.home-form-cont-formCont{
  width: 50%;
}
.home-form-cont-formImg{
  width: 50%;
  padding: 4% 0 4%;
}
.home-form-cont-formImg img{
  width: 100%;
  height: 100%;
  object-fit: scale-down;
}
.form-group{
  display: flex;
  flex-direction: column;
}
.custom-button {
    background: #1E1E1E;
    border-radius: 10px;
    font-size: 0.8vw;
    padding: 0.5vw 1.5vw;
    border-color: #1E1E1E;
    margin-bottom: 8%;
}
/* form end ===================================  */
</style>

